import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/fr/messages';
import { messages as retailMessages } from '../translations/autohero-common/fr/messages';

activateI18n('fr', {
  ...retailMessages,
  ...sellOnlyMessages,
});
